<template>
    <div class="document-frame">
        <div
            v-if="editable"
            class="document-container d-flex align-items-center"
        >
            <div
                v-for="(attachment, attachment_index) in value"
                class="document-item"
                :key="attachment_index"
            >
                <template v-if="isImage(attachment)">
                    <i
                        class="icon-close"
                        @click="deleteFile(attachment_index)"
                    ></i>
                    <div
                        class="document is-img"
                        @click="viewFile(attachment_index)"
                    >
                        <img
                            :src="attachment"
                            alt="N/A"
                        />
                    </div>
                </template>
                <template v-else-if="isPDF(attachment)">
                    <i
                        class="icon-close"
                        @click="deleteFile(attachment_index)"
                    ></i>
                    <div
                        class="document is-pdf"
                        @click="openFile(attachment)"
                    >
                        <i class="icon-pdf"></i>
                    </div>
                </template>
                <template v-else-if="isZIP(attachment)">
                    <div class="document is-zip">
                        <span>
                            <i
                                class="icon-close"
                                @click="deleteFile(attachment_index)"
                            ></i>
                            <span @click="openFile(attachment)"> test.zip </span>
                        </span>
                    </div>
                </template>
            </div>
            <div class="document-add">
                <label class="file-upload">
                    <i class="icon icon-attachfile"></i>
                    <input
                        :ref="'fileUpload'"
                        type="file"
                        multiple="multiple"
                        class="input_add_document"
                        accept=".png,.jpg,.jpeg,.bmp,.webp,.svg,image/png,image/jpeg,image/x-ms-bmp,image/x-bmp,image/webp,image/svg+xml"
                        @input="uploadImageHandler($event, value)"
                    />
                </label>
            </div>
        </div>
        <div
            v-else
            class="document-container d-flex align-items-center"
        >
            <div v-if="!value || value.length === 0">-</div>
            <div
                v-else
                v-for="(attachment, attachment_index) in value"
                class="document-item"
                :key="attachment_index"
            >
                <template v-if="attachment_index <= meta.length">
                    <template v-if="attachment_index == meta.length">
                        <div class="document is-img">
                            <span @click="showDropdown = !showDropdown"> +{{ value.length - meta.length }} </span>
                        </div>
                        <div
                            v-if="showDropdown && value.length > meta.length"
                            aria-labelledby="dropdownAddItem"
                            class="dropdown-menu dropdown-menu-right"
                            style="display: block; float: right"
                            v-click-outside="hidePopup"
                        >
                            <div class="popup-trigger">
                                <div class="quick-search-group">
                                    <template v-for="(attachment, attachment_index) in value">
                                        <template v-if="attachment_index >= meta.length">
                                            <div
                                                class="document is-zip"
                                                :key="attachment_index"
                                            >
                                                <span
                                                    v-if="isImage(attachment)"
                                                    @click="viewFile(attachment_index)"
                                                >
                                                    {{ getFileName(attachment) }}
                                                </span>
                                                <span
                                                    v-else-if="isPDF(attachment)"
                                                    @click="openFile(attachment)"
                                                >
                                                    {{ getFileName(attachment) }}
                                                </span>
                                                <span
                                                    v-else-if="isZIP(attachment)"
                                                    @click="openFile(attachment)"
                                                >
                                                    {{ getFileName(attachment) }}
                                                </span>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div
                        v-else-if="isImage(attachment)"
                        class="document is-img"
                        @click="viewFile(attachment_index)"
                    >
                        <img
                            :src="attachment"
                            alt="N/A"
                        />
                    </div>
                    <div
                        v-else-if="isPDF(attachment)"
                        class="document is-pdf"
                        @click="openFile(attachment)"
                    >
                        <i class="icon-pdf"></i>
                    </div>
                </template>
                <div
                    v-if="isZIP(attachment)"
                    class="document is-zip"
                    @click="openFile(attachment)"
                >
                    <span> test.zip </span>
                </div>
            </div>
        </div>
        <!-- <light-box ref="imageViewer" :media="lightboxImages" :showLightBox="showLightBox"></light-box> -->
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

// import LightBox from "vue-image-lightbox";
// import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";

import vClickOutside from "v-click-outside";
import mediaMixin from "@/v2/mixins/medias.js";
Vue.use(vClickOutside);

export default {
    props: ["id", "editable", "value", "meta", "url"],

    data() {
        return {
            lightboxImages: [
                {
                    // need have image by default, else will throw error
                    thumb: "/assets/graphics/img-product.svg",
                    src: "/assets/graphics/img-product.svg",
                },
            ],
            // showLightBox: false,
            showDropdown: false,
        };
    },
    mixins: [mediaMixin],
    // components: {
    //     LightBox,
    // },

    methods: {
        getFileName(url) {
            //https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
            return url.slice((Math.max(0, url.lastIndexOf("/")) || Infinity) + 1);
        },

        getFileExtension(filename) {
            //https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
            return filename.slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1);
        },

        isImage(filename) {
            let fileExtension = this.getFileExtension(filename);
            return (
                fileExtension === "svg" ||
                fileExtension === "jpg" ||
                fileExtension === "png" ||
                fileExtension === "jpeg" ||
                fileExtension === "jfif" ||
                fileExtension === "gif" ||
                fileExtension === "bmp" ||
                fileExtension === "webp"
            );
        },

        isPDF(filename) {
            let fileExtension = this.getFileExtension(filename);
            return fileExtension === "pdf";
        },

        isZIP(filename) {
            let fileExtension = this.getFileExtension(filename);
            return fileExtension === "zip";
        },

        addFiles(event, attachmentList) {
            var self = this;
            var invalidFile = [];

            event.target.files.forEach((file, index) => {
                if (0 === file.type.indexOf("image/")) {
                    this.$emit("loading");

                    let formData = new FormData();
                    formData.append("file", file, { type: file.type });
                    axios
                        .post(this.url, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((response) => {
                            const items = attachmentList.concat(response.data.url);
                            this.$emit("change", items);
                        })
                        .catch((error) => {
                            console.log(error.message);
                            alert(
                                "Following file cannot be uploaded:\n\n- " + file.name + "\n\n" + error.message,
                                "Server Error"
                            );
                        });
                } else {
                    invalidFile.push(file.name);
                }

                this.$emit("done_loading");
            });

            if (invalidFile.length) {
                alert("Following files cannot be uploaded:\n\n- " + invalidFile.join("\n-"), "Invalid File Type");
            }

            event.target.files = null;
        },

        deleteFile(index) {
            const items = this.value;
            delete items[index];
            let temp = Object.assign({}, items);
            this.$emit("change", temp);
        },
        uploadImageHandler(event, attachmentList) {
            this.uploadImages(event.currentTarget.files, attachmentList);
            event.target.files = null;
        },
        uploadImages(files, attachmentList) {
            if (files.length > this.max) {
                this.error = `Maximum number of files is ` + this.max;
                return;
            }
            this.error = "";

            files.forEach((file) => {
                let temp = Object.assign({}, attachmentList);

                this.createMedia(file, (media) => {
                    temp[media.id] = media.source_url_medium;
                    attachmentList = temp;
                    this.$emit("change", attachmentList);
                });
            });
        },
        viewFile(index) {
            var lightboxImages = [];
            let temp = Object.assign({}, this.value);
            for (const [key, value] of Object.entries(temp)) {
                lightboxImages.push({
                    thumb: value,
                    src: value,
                    id: key,
                });
            }
            this.lightboxImages = lightboxImages;
            const _index = this.lightboxImages.findIndex((i) => i.id == index);
            // this.$refs.imageViewer.showImage(_index);

            viewerApi({
                options: {
                    inline: true,
                    button: true,
                    navbar: true,
                    title: false,
                    toolbar: false,
                    tooltip: true,
                    movable: true,
                    zoomable: true,
                    rotatable: false,
                    scalable: false,
                    transition: true,
                    fullscreen: true,
                    keyboard: true,
                    url: "src",
                    initialViewIndex: _index,
                },
                images: this.lightboxImages,
            });
        },

        openFile(url) {
            window.open(url, "_blank");
        },

        resetFileInput() {
            this.$refs.fileUpload.value = null;
        },

        hidePopup() {
            this.showDropdown = false;
        },
    },
};
</script>
